export default "__VITE_ASSET__CEJeU4RX__"